import React from "react";
import {Carousel} from 'react-responsive-carousel';
import {Col, Row} from "antd";
import styles from './index.module.scss';

const feedbacksList = [
  {
    title: "Rosa Maria M.",
    text: "Oggi pomeriggio ho avuto la fortuna di conoscere il signor Vincenzo. Ci siamo sentiti per la nuova" +
      " versione del programma MyEdu Family. Persona molto preparata, professionale, competente e anche simpatico." +
      " Per una persona come me che di computer ne sa veramente poco, direi che dopo la telefonata con Vincenzo," +
      " sono riuscita a capire molto bene…",
  },
  {
    title: "Federica",
    text: "Ho appena attivato la piattaforma e ne sono molto entusiasta, complimenti!",
  },
  {
    title: "Antonella A.",
    text: "insegnante – IC Fanciulli (TR) Grazie, è una piattaforma molto interessante.",
  },
  {
    title: "IC CARMAGNOLA 2",
    text: "Carmagnola (TO) L’Istituto ha aderito alla proposta che MyEdu rivolge alle scuole con il patrocinio " +
      "del MIUR per la promozione dell’innovazione tecnologica nella didattica." +
      "Dopo un breve periodo di formazione per l’accesso alla piattaforma e ai suoi ricchi contenuti didattici, " +
      "i Docenti avranno la possibilità di accedere a risorse multimediali, video, animazioni, documenti relativi alle " +
      "materie di studio per predisporre le lezioni e le attività in classe e guideranno gli alunni all’uso dei " +
      "materiali durante l’orario scolastico.",
  },
  {
    title: "Ana Liliana T.",
    text: "Anche mia figlia usa MyEdu. È ottimo!",
  },
  {
    title: "Dott.sa Ilaria Cambiaghi",
    text: "Siamo noi molto contenti della piattaforma, le insegnanti si stanno trovando molto bene!",
  },
  {
    title: "Alexandra",
    text: "Volevo ringraziare tutti coloro che si sono occupati della spedizione celerissima del tablet e " +
      "coloro che ci hanno risposto prontamente per reperire alcune info nell’app. Grazie siete una bella squadra :)",
  },
  {
    title: "Ilaria R.",
    text: "Buongiorno, io e mio figlio utilizziamo la piattaforma da l’anno scorso. È veramente utilissima, " +
      "ricca di informazioni e spazia su tutto. Gli operatori che lavorano per la piattaforma sono supergentili!! " +
      "In particolare sono stracontenta di essere stata aiutata da Vincenzo, gentilissimo e super paziente."
  },
];

const Feedbacks = () => {
  return (
    <Row
      className={styles.feedbacksMainRow}
      gutter={16}
    >
      <h2>Testimonianze</h2>
      <Carousel
        className={styles.carousel}
        transitionTime={1000}
        showStatus={false}
        showThumbs={false}
        showIndicators={false}
        autoPlay={false}
        infiniteLoop
        useKeyboardArrows
      >
        {
          feedbacksList.map(feedback => (
            <Col
                key={JSON.stringify(feedback)}
              xs={24}
              className={styles.feedbackCol}
            >
              <p className={styles.feedbackTitle}>
                <strong>
                  {feedback.title}
                </strong>
              </p>
              <p>{feedback.text}</p>
            </Col>
          ))
        }
      </Carousel>
    </Row>
  )
}

export default Feedbacks;
